import { getStartInfo } from "./start-info";
export function getAll() {
    const { fetchCommands } = getStartInfo();
    return fetchCommands();
}
export function get(id) {
    const storedCommands = getAll();
    return storedCommands[id] || null;
}
export function getIds() {
    const storedCommands = getAll();
    return Object.keys(storedCommands);
}
export async function add(commands) {
    const { logger, persistCommands } = getStartInfo();
    let commandStorageModified = false;
    const commandsToStore = getAll();
    for (const command of commands) {
        if (typeof commandsToStore[command.ipm_id] !== "undefined") {
            logger.debug("[ipm]: Campaign already stored:", command.ipm_id);
            continue;
        }
        commandsToStore[command.ipm_id] = command;
        commandStorageModified = true;
    }
    if (commandStorageModified) {
        await persistCommands(commandsToStore);
    }
}
export async function remove(id) {
    const { fetchCommands, persistCommands } = getStartInfo();
    const command = get(id);
    if (!command) {
        return;
    }
    const commandsToStore = fetchCommands();
    delete commandsToStore[command.ipm_id];
    await persistCommands(commandsToStore);
}
